import { registerRootComponent } from 'expo';
import KakeiboApp from './src/App';

// registerRootComponent ensures the environment is set up appropriately for native and web
registerRootComponent(KakeiboApp);

// Also export default so bundlers that `import App from '../../App'` find a default export
export default KakeiboApp;
